import { render, staticRenderFns } from "./RecordBox.vue?vue&type=template&id=26f428c6&"
import script from "./RecordBox.vue?vue&type=script&lang=js&"
export * from "./RecordBox.vue?vue&type=script&lang=js&"
import style0 from "./RecordBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports